import React from 'react';
import { Check } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { WizardStep } from '../common';

const ProgressIndicator = ({ activeStep, completedSteps, onStepClick }) => {
    const STEPS = [
        { step: WizardStep.POSITION_DETAILS, label: 'BASIC DETAILS' },
        { step: WizardStep.TALENT_INSIGHTS, label: 'SKILL DETAILS' },
        { step: WizardStep.JOB_DESCRIPTION, label: 'JOB DESCRIPTION' },
        { step: WizardStep.PREVIEW_SUBMIT, label: 'PREVIEW & SUBMIT' },
    ];

    return (
        <Box sx={{ position: 'relative', mb: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative' }}>
                {/* Single continuous gray line */}
                <Box
                    sx={{
                        position: 'absolute',
                        top: 16,
                        left: '6%',
                        right: '4%',
                        height: 2,
                        bgcolor: 'grey.200',
                        width: '88%',
                    }}
                />

                {/* Progress line */}
                <Box
                    sx={{
                        position: 'absolute',
                        top: 16,
                        left: '6%',
                        height: 2,
                        bgcolor: '#ED7342',
                        transition: 'all 0.3s',
                        width: `${(STEPS.findIndex((s) => s.step === activeStep) / (STEPS.length - 1)) * 86}%`,
                    }}
                />

                {STEPS.map((step, index) => {
                    const isActive = step.step === activeStep;
                    const isCompleted = completedSteps.includes(step.step);
                    const isPreviousStep = STEPS.findIndex((s) => s.step === activeStep) > index;
                    const isClickable = isPreviousStep || isCompleted;

                    return (
                        <Box
                            key={step.step}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                position: 'relative',
                                zIndex: 10,
                            }}
                        >
                            {/* Circle */}
                            <Button
                                onClick={() => isClickable && onStepClick(step.step)}
                                disabled={!isClickable}
                                sx={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mb: 1,
                                    minWidth: 'auto',
                                    p: 0,
                                    bgcolor: isCompleted || isActive ? '#ED7342' : 'grey.200',
                                    color: isCompleted || isActive ? 'white' : 'grey.500',
                                    cursor: isClickable ? 'pointer' : 'not-allowed',
                                    '&:hover': {
                                        bgcolor: isClickable
                                            ? '#ED7342'
                                            : isCompleted || isActive
                                              ? '#ED7342'
                                              : 'grey.200',
                                        opacity: isClickable ? 0.9 : 1,
                                    },
                                    '&:disabled': {
                                        bgcolor: isCompleted || isActive ? '#ED7342' : 'grey.200',
                                        color: isCompleted || isActive ? 'white' : 'grey.500',
                                    },
                                }}
                            >
                                {isCompleted && <Check sx={{ fontSize: 16, color: 'white' }} />}
                            </Button>

                            {/* Label */}
                            <Typography
                                variant="body2"
                                sx={{
                                    fontWeight: 500,
                                    whiteSpace: 'nowrap',
                                    color: isActive || isCompleted ? '#ED7342' : 'grey.500',
                                    fontSize: '0.875rem',
                                }}
                            >
                                {step.label}
                            </Typography>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
};

export default ProgressIndicator;
